import React, { useRef, useEffect } from 'react';
import useDataVersion from '../hooks/useDataVersion';

const API = process.env.REACT_APP_BACKEND_URL || '';

/**
 * Price Trend Dashboard
 * Iframe-based; the HTML fetches grouped rates from /api/price-trend/data.
 */
const PriceTrendPage = () => {
  const iframeRef = useRef(null);

  useEffect(() => { window.REACT_APP_BACKEND_URL = API; }, []);

  useDataVersion('rates', () => {
    if (iframeRef.current) {
      iframeRef.current.src = iframeRef.current.src.split('?')[0] + '?_=' + Date.now();
    }
  }, { toastLabel: 'Price Trend data' });

  return (
    <div className="w-full h-full min-h-screen bg-white" data-testid="price-trend-page">
      <iframe
        ref={iframeRef}
        src="/price-trend1.html"
        title="Price Trend Dashboard"
        className="w-full border-0"
        style={{ height: 'calc(100vh - 4rem)', minHeight: '900px' }}
      />
    </div>
  );
};

export default PriceTrendPage;
